import { createSlice } from '@reduxjs/toolkit';
import {
  getAllOneDayBooking,
  deleteOneDayBooking,
  createOneDayBooking,
  getDetailOneDayBooking,
  updateOneDayBooking,
} from './actions';

const initialState = {
  data: {},
  selectedOneDayBooking: {},
  isLoading: false,
  isError: false,
  errorMessage: {}, // kalo retry setelah error, harus hapus errorMessage dan isError!
};

export const oneDayBooking = createSlice({
  name: 'oneDayBooking',
  initialState,
  reducers: {
    // reducers goes here

    resetSelectedOneDayBooking: (state) => {
      state.selectedOneDayBooking = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllOneDayBooking.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.data = {};
      })
      .addCase(getAllOneDayBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getAllOneDayBooking.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDetailOneDayBooking.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.selectedOneDayBooking = {};
      })
      .addCase(getDetailOneDayBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getDetailOneDayBooking.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedOneDayBooking = action.payload;
      })
      .addCase(createOneDayBooking.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(createOneDayBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(createOneDayBooking.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteOneDayBooking.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(deleteOneDayBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(deleteOneDayBooking.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateOneDayBooking.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
      })
      .addCase(updateOneDayBooking.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(updateOneDayBooking.fulfilled, (state) => {
        state.isLoading = false;
      });
  },
});

export const { resetSelectedOneDayBooking } = oneDayBooking.actions;
export default oneDayBooking.reducer;
